import React, { forwardRef, useEffect, useMemo } from "react"
import { useAuth } from "../../contexts/Auth";

export const InternalOqt = React.memo(forwardRef((props, ref) => {
  const {name, claim, formik, prepare} = props;
  const auth = useAuth();
  const value = auth && auth.auth && auth.auth[claim];
  //console.log({auth, value, name, claim})
  useEffect(()=>{
    formik.setFieldValue(name, !!prepare ? eval(prepare)(value) : value);
  }, [value, prepare]);
  return <input type="hidden" name={name} value={value} />
}))

